/**
 * @fileoverview Agent definition for run-refine-v2.
 *
 * This is a COMPOSITE agent that orchestrates a two-step pipeline:
 * 1. refine-synthesizer: Synthesizes findings/weaknesses/strengths into an editorial brief
 * 2. draft-refiner-v2: Refines the chapter based on the editorial brief
 *
 * The result is refined chapter content that addresses the selected issues
 * while preserving identified strengths.
 *
 * @category writing.refinement.session
 * @type composite
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'run-refine-v2',
  kind: 'composite',
  name: 'Run Refine Session',
  description: 'Processes a refine session by synthesizing issues into an editorial brief and refining the chapter accordingly.',
  category: 'writing',
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata ---
  metadata: {
    status: 'active',
    type: 'composite',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    usedBy: [
      'use-run-refine.ts',
    ],
    // Composite agents specify which primitives they orchestrate
    composedOf: [
      'refine-synthesizer',
      'draft-refiner-v2',
    ],
    relatedAgents: ['refine-synthesizer', 'draft-refiner-v2', 'auto-gather'],
    taxonomyPath: 'writing.refinement.session',
  },
};
